const PTEntertainment = [
    {
        title: 'Rainha Letizia apoia moda espanhola e estreia look em visita a Sevilha',
        description: 'Os reis Felipe VI e Letizia seguem na sua digressão nacional e esta segunda-feira, dia 29, visitaram a cidade de Sevilha, a propósito deste retomar da normalidade depois de Espanha se ter visto duramente afetada pela pandemia da Covid-19.',
        url: 'https://www.noticiasaominuto.com/fama/1519310/rainha-letizia-apoia-moda-espanhola-e-estreia-look-em-visita-a-sevilha',
        image: 'https://media-manager.noticiasaominuto.com/960/naom_5efa164fb8e7c.jpg',
        publishedAt: '2020-06-29T17:30:00Z',
        source: {
            name: 'Noticias ao Minuto',
            url: 'https://www.noticiasaominuto.com/'
        }
    },
    {
        title: 'Alucinado, Mateus crava punhal no peito',
        description: 'Em «Quer o Destino», Carlos (João Vicente) entra no quarto de Mateus (Pedro Teixeira) à procura de Vitória (Sara Barradas). Mateus faz-se de desentendido. Carlos perde a paciência com os sarcasmos do veterinário e decide ir-se embora. Mateus chama-o e olha-o fixamente, enquanto espeta um punhal no peito. Carlos fica em pânico.',
        url: 'https://tvi.iol.pt/querodestino/fotos/alucinado-mateus-crava-punhal-no-peito/5ef9db4c0cf2a5883421a2c9',
        image: 'https://www.iol.pt/multimedia/oratvi/multimedia/imagem/id/5ef9db4b0cf2c4d7ff3fa7a4/1814',
        publishedAt: '2020-06-29T17:30:00Z',
        source: {
            name: 'TVI',
            url: 'https://tvi.iol.pt/'
        }
    },
    {
        title: 'Acompanhe o Marítimo - Benfica AO MINUTO',
        description: 'Encontro arranca às 18h00. O Benfica enfrenta esta segunda-feira o Marítimo, a partir das 18h00, em jogo a contar para a 29ª jornada do campeonato nacional.',
        url: 'https://desporto.sapo.pt/futebol/primeira-liga/artigos/acompanhe-o-maritimo-benfica-ao-minuto',
        image: 'https://thumbs.web.sapo.io/?W=910&H=0&delay_optim=1&webp=1&epic=OGJhdwePQAX4n3w1iWy1eoC1F806M1OMce3/47kuMhoHxZEJmTDYDxJFfEBSQOvdRMBpWCv1Bqm96sjnOQIf7wPHxdnmWA4JwoSrlfxXFwEFwwI=',
        publishedAt: '2020-06-29T17:58:00Z',
        source: {
            name: 'Sapo',
            url: 'https://desporto.sapo.pt/'
        }
    },
    {
        title: 'Homem é apanhado em flagrante a raptar criança de 2 anos e continua em liberdade',
        description: 'De acordo com a polícia alemã, não estavam reunidas todas as condições para a detenção do raptor. O homem estava alcoolizado, e admitiu que a criança não lhe pertencia quando foi apanhado. Foi num parque infantil alemão, em Berlim, que uma mãe reparou na ausência da filha de 2 anos, momentos depois de se distrair a conversar com outra pessoa.',
        url: 'https://magg.sapo.pt/atualidade/artigos/homem-e-apanhado-em-flagrante-a-raptar-crianca-de-2-anos-e-continua-em-liberdade',
        image: 'https://thumbs.web.sapo.io/?W=1200&H=630&delay_optim=1&tv=1&crop=center&bottom_overlay=https%3A%2F%2Fmagg.sapo.pt%2Fassets%2Fimg%2Fmagg%2Ffacebook-overlay.png&epic=ODc3p5fsBG/3J6Leg6/1K/eIiaw5F2SHJWkUL/xtAfm+IsdJyAdkgoZQAkUml6BTpG9QyvaZ6c9zg/DdGXqC3DaipGHnOhKydS5d1UZGOlho0j4=',
        publishedAt: '2020-06-29T16:11:00Z',
        source: {
            name: 'Sapo',
            url: 'https://magg.sapo.pt/'
        }
    },
    {
        title: '"Obama, o que vamos fazer? Injetá-lo com a gripe de Wuhan": Sacha Baron Cohen infiltra-se em comício de extrema-direita nos EUA',
        description: 'De chapéu, jardineiras e com barba e cabelo falsos, Sacha Baron Cohen fingiu ser um cantor country racista e atuou no comício “March for Our Rights 3”, organizado pela Washington Three Percenters, um movimento com ligações à extrema-direita, em Washington, no sábado.',
        url: 'https://observador.pt/2020/06/29/obama-o-que-vamos-fazer-injeta-lo-com-a-gripe-de-wuhan-sacha-baron-cohen-infiltra-se-em-comicio-de-extrema-direita-nos-eua/',
        image: 'https://wm.observador.pt/wm/obs/l/https%3A%2F%2Fbordalo.observador.pt%2F770x403%2Cq80%2Fhttps%3A%2F%2Fs3.observador.pt%2Fwp-content%2Fuploads%2F2020%2F06%2F29135457%2F512996940_770x433_acf_cropped.jpg',
        publishedAt: '2020-06-29T13:05:00Z',
        source: {
            name: 'Observador',
            url: 'https://observador.pt/'
        }
    },
    {
        title: 'YouTube. Grupo de "K-Pop" quebra recorde de visualizações em 24 horas',
        description: 'O grupo feminino Blackpink de pop sul-coreana (K-Pop) é o mais recente detentor do recorde de maior número de visualizações no espaço de 24 horas para um vídeo no YouTube. Diz a Variety que o vídeo do single ‘How You Like That’ foi visto 82.4 milhões de vezes nas primeiras 24 horas.',
        url: 'https://www.noticiasaominuto.com/tech/1518964/youtube-grupo-de-k-pop-quebra-recorde-de-visualizacoes-em-24-horas',
        image: 'https://media-manager.noticiasaominuto.com/1280/1593426092/naom_5ef9c04f088a3.jpg?crop_params=eyJwb3J0cmFpdCI6eyJjcm9wV2lkdGgiOjcxOCwiY3JvcEhlaWdodCI6MTA3NywiY3JvcFgiOjYyNywiY3JvcFkiOjB9LCJsYW5kc2NhcGUiOnsiY3JvcFdpZHRoIjoxODk3LCJjcm9wSGVpZ2h0IjoxMDY1LCJjcm9wWCI6OSwiY3JvcFkiOjN9fQ==',
        publishedAt: '2020-06-29T11:16:00Z',
        source: {
            name: 'Noticias ao Minuto',
            url: 'https://www.noticiasaominuto.com/'
        }
    },
    {
        title: 'A Expulsão de Daniel Monteiro da Casa do Big Brother',
        description: 'No «Você na TV!», revemos as imagens do momento em que o concorrente abandona a casa. Admite que percebeu que seria ele ser expulso.',
        url: 'https://tvi.iol.pt/vocenatv/videos/a-expulsao-de-daniel-monteiro-da-casa-do-big-brother/5ef9b26b0cf2634381af37a8',
        image: 'https://www.iol.pt/multimedia/oratvi/multimedia/imagem/id/5ef9b4e10cf2c4d7ff3fa6eb/',
        publishedAt: '2020-06-29T10:00:00Z',
        source: {
            name: 'TVI',
            url: 'https://tvi.iol.pt/'
        }
    },
    {
        title: 'Vídeo: Jessica Athayde desfruta de bons momentos com o filho',
        description: 'A atriz aproveitou as altas temperaturas para mergulhar numa piscina com o menino. Desde que foi mãe pela primeira vez há um ano que o filho é o grande destaque da sua página de Instagram.',
        url: 'https://www.noticiasaominuto.com/fama/1519075/video-jessica-athayde-desfruta-de-bons-momentos-com-o-filho',
        image: 'https://media-manager.noticiasaominuto.com/1280/1593433066/naom_5ef9db97e75ab.jpg?crop_params=eyJwb3J0cmFpdCI6eyJjcm9wV2lkdGgiOjU0NywiY3JvcEhlaWdodCI6OTczLCJjcm9wWCI6NzksImNyb3BZIjo2fSwibGFuZHNjYXBlIjp7ImNyb3BXaWR0aCI6MTM0NCwiY3JvcEhlaWdodCI6NzU2LCJjcm9wWCI6NjMsImNyb3BZIjo2NX19',
        publishedAt: '2020-06-29T13:19:00Z',
        source: {
            name: 'Noticias ao Minuto',
            url: 'https://www.noticiasaominuto.com/'
        }
    },
    {
        title: 'Taylor Schilling, de "Orange is the New Black", confirma relação',
        description: 'A protagonista da série da Netflix assumiu publicamente a homossexualidade. Depois de todos os rumores sobre a sua orientação sexual, Taylor Schilling aproveitou as celebrações do Orgulho Gay para assumir publicamente a homossexualidade.',
        url: 'https://www.noticiasaominuto.com/fama/1519038/taylor-schilling-de-orange-is-the-new-black-confirma-relacao',
        image: 'https://media-manager.noticiasaominuto.com/1280/1593431160/naom_5ef9d3fbcccd5.jpg?crop_params=eyJwb3J0cmFpdCI6eyJjcm9wV2lkdGgiOjg5NCwiY3JvcEhlaWdodCI6MTU4OCwiY3JvcFgiOjk1NywiY3JvcFkiOjU1fSwibGFuZHNjYXBlIjp7ImNyb3BXaWR0aCI6MCwiY3JvcEhlaWdodCI6MCwiY3JvcFgiOjAsImNyb3BZIjowfX0=',
        publishedAt: '2020-06-29T12:52:00Z',
        source: {
            name: 'Noticias ao Minuto',
            url: 'https://www.noticiasaominuto.com/'
        }
    },
    {
        title: 'Kylie Jenner mostra-se em biquíni e fala de "quilos da quarentena"',
        description: 'A celebridade diz que engordou durante estes dias que esteve em isolamento social, como destacou nas redes sociais. Kylie Jenner recorreu às stories da sua página de Instagram para destacar a forma física, especialmente depois de ter estado estes últimos tempos de quarentena por causa da pandemia da Covid-19.',
        url: 'https://www.noticiasaominuto.com/fama/1519028/kylie-jenner-mostra-se-em-biquini-e-fala-de-quilos-da-quarentena',
        image: 'https://media-manager.noticiasaominuto.com/1280/1593430136/naom_5ef9d0187cd33.jpg?crop_params=eyJwb3J0cmFpdCI6eyJjcm9wV2lkdGgiOjUyOSwiY3JvcEhlaWdodCI6Nzg1LCJjcm9wWCI6MTExLCJjcm9wWSI6NDR9LCJsYW5kc2NhcGUiOnsiY3JvcFdpZHRoIjowLCJjcm9wSGVpZ2h0IjowLCJjcm9wWCI6MCwiY3JvcFkiOjB9fQ==',
        publishedAt: '2020-06-29T12:51:00Z',
        source: {
            name: 'Noticias ao Minuto',
            url: 'https://www.noticiasaominuto.com/'
        }
    },
    {
        title: 'Mansão de luxo do "Big Brother" está à venda!',
        description: 'O anúncio ainda está disponível numa agência imobiliária. Acasa de luxo onde os concorrentes do "Big Brother" se encontram neste momento está à venda. Tal pode ser verificado através do anúncio da imobiliária Classical Reason no seu próprio website.',
        url: 'https://www.noticiasaominuto.com/fama/1518912/mansao-de-luxo-do-big-brother-esta-a-venda',
        image: 'https://media-manager.noticiasaominuto.com/1280/naom_5ef9ab86b7f31.jpg',
        publishedAt: '2020-06-29T09:50:00Z',
        source: {
            name: 'Noticias ao Minuto',
            url: 'https://www.noticiasaominuto.com/'
        }
    },
    {
        title: 'É assim que William e Kate educam os filhos',
        description: 'De acordo com a imprensa britânica, os duques de Cambridge nunca levantam a voz a George, Charlotte ou Louis. Os elementos da família real britânica concentram os olhares de milhões de pessoas mesmo antes de nascerem, uma ‘fama’ que vão mantendo durante toda a vida.',
        url: 'https://caras.sapo.pt/realeza/2020-06-29-e-assim-que-william-e-kate-educam-os-filhos/#&gid=0&pid=1',
        image: 'https://images.trustinnews.pt/uploads/sites/6/2020/06/15807299william-e-kate-postal-de-natal_wm.jpg',
        publishedAt: '2020-06-29T09:50:00Z',
        source: {
            name: 'Sapo',
            url: 'https://caras.sapo.pt/'
        }
    },
    {
        title: 'Pedro Miguel Ramos partilha primeira imagem ao lado de Marta Leite Castro',
        description: 'Pedro Miguel Ramos celebrou o 49.º aniversário rodeado de amigos, entre eles a nova namorada, a apresentadora Marta Leite Castro. Pedro Miguel Ramos completou 49 anos, no passado dia 26, e, durante o fim de semana, celebrou com os amigos.',
        url: 'https://selfie.iol.pt/aniversario/romance/pedro-miguel-ramos-partilha-primeira-imagem-ao-lado-de-marta-leite-castro',
        image: 'https://img.iol.pt/preset/5eea1ef20cf29545b5725575/og/selfie',
        publishedAt: '2020-06-29T11:01:18Z',
        source: {
            name: 'IOL',
            url: 'https://selfie.iol.pt/'
        }
    },
    {
        title: 'Ninguém o cala! Júlio Isidro responde aos críticos... mas com muita classe',
        description: 'Júlio Isidro, um dos apresentadores mais respeitados da televisão portuguesa, não se coibiu de dar a sua opinião sobre o trabalho de Filomena Cautela na condução do concurso da estação pública "Quem Quer Ser Milionário".',
        url: 'https://www.flash.pt/atualidade/nacional/detalhe/ninguem-o-cala-julio-isidro-responde-aos-criticos-mas-com-muita-classe',
        image: 'http://cdn.flash.pt/images/2020-06/img_1200x676$2020_06_29_11_25_21_254675_im_637290268003119757.png',
        publishedAt: '2020-06-29T10:42:00Z',
        source: {
            name: 'Flash',
            url: 'https://www.flash.pt/'
        }
    },
    {
        title: 'João deixa Hugo encurralado',
        description: 'Em «Quer o Destino», Hugo (Rodrigo Trindade) apressa-se, enquanto João (Isaac Alfaiate) lhe pergunta onde vai. Hugo disfarça. João pergunta se sabe do irmão, mas Hugo diz que não sabe e pede para os deixarem em paz.',
        url: 'https://tvi.iol.pt/querodestino/fotos/joao-deixa-hugo-encurralado/5ef9fd500cf2634381af39f1',
        image: 'https://www.iol.pt/multimedia/oratvi/multimedia/imagem/id/5ef9fd4f0cf29545b572891b/',
        publishedAt: '2020-06-29T18:13:26Z',
        source: {
            name: 'TVI',
            url: 'https://tvi.iol.pt/'
        }
    },
    {
        title: 'Cláudia Vieira mostra as filhas com fatos de banho a combinar',
        description: 'Cláudia Vieira está a passar uns dias relaxantes em família em Tróia. E volta a provar que as filhas têm uma forte ligação e cumplicidada. Tanto que até gostam de usar roupa a combinar.',
        url: 'https://caras.sapo.pt/famosos/2020-06-29-claudia-vieira-mostra-as-filhas-com-fatos-de-banho-a-combinar/#&gid=0&pid=1',
        image: 'https://images.trustinnews.pt/uploads/sites/6/2020/06/82800025_1144778135921466_3181793238433374642_n_wm.jpg',
        publishedAt: '2020-06-29T16:04:00Z',
        source: {
            name: 'Sapo',
            url: 'https://caras.sapo.pt/'
        }
    },
    {
        title: 'EUA. Comediante disfarçado lança o caos em comício de extrema-direita',
        description: 'Sacha Baron Cohen, o comediante britânico conhecido pela criação de figuras como "Borat", apresentou-se para actuar num comício da extrema-direita e ridicularizou o evento com uma canção racista. Depois, desapareceu nos bastidores.',
        url: 'https://www.rtp.pt/noticias/cultura/eua-comediante-disfarcado-lanca-o-caos-em-comicio-de-extrema-direita_n1240958',
        image: 'https://cdn-images.rtp.pt/icm/noticias/images/44/44464bde933fa8b7b76a49cdf86cffbc?w=860&q=90&rect=0,0,1499,822&auto=format',
        publishedAt: '2020-06-29T15:39:00Z',
        source: {
            name: 'RTP',
            url: 'https://www.rtp.pt/'
        }
    },
    {
        title: 'Tiago Rufino arrasa mãe de Sónia do "Big Brother": "Momento tristíssimo e de uma baixeza incrível!"',
        description: 'A passada gala do "Big Brother" foi, uma vez mais, palco de fortes emoções e quem não ficou indiferente à grande noite foi Tiago Rufino, o vencedor da sétima edição da "Casa dos Segredos".',
        url: 'https://selfie.iol.pt/casa-dos-segredos/polemica/tiago-rufino-arrasa-mae-de-sonia-do-big-brother-momento-tristissimo-e-de-uma-baixeza-incrivel',
        image: 'https://img.iol.pt/preset/5ef9d8250cf2a5883421a2ad/og/selfie',
        publishedAt: '2020-06-29T09:50:00Z',
        source: {
            name: 'IOL',
            url: 'https://selfie.iol.pt/'
        }
    },
    {
        title: 'A nova série documental sobre a investigação a um serial killer perturbador',
        description: 'Esta é a história de um predador violento que ficou conhecido como Golden State Killer. Ao longo dos anos 70 e 80, este criminoso anónimo, que ninguém sabia quem era, foi responsável por 50 violações em invasões a residências — e cometeu 12 homicídios.',
        url: 'https://nit.pt/cultura/televisao/ha-uma-nova-serie-documental-sobre-uma-investigacao-um-serial-killer-perturbador',
        image: 'https://nit.pt/wp-content/uploads/2020/06/91fd86d4a91494307724e3811e7788c1-770x403.jpg',
        publishedAt: '2020-06-29T12:40:00Z',
        source: {
            name: 'Nit',
            url: 'https://nit.pt/'
        }
    },
    {
        title: '“Pena um dia não sentires uma mão bem assente”: Criticada, “A Pipoca” reage de forma hilariante',
        description: 'A comentadora do “Big Brother 2020” Ana Garcia Martins, mais conhecida por “A Pipoca Mais Doce”, já revelou receber recorrentemente mensagens insultuosas e ameaçadoras, mais concretamente por parte de pessoas do Norte. Este fim-de-semana, decidiu mostrar o conteúdo de uma delas, que lhe foi enviada por e-mail.',
        url: 'https://www.hiper.fm/pena-um-dia-nao-sentires-uma-mao-bem-assente-criticada-a-pipoca-reage-de-forma-hilariante/',
        image: 'https://www.hiper.fm/wp-content/uploads/2020/06/Captura-de-ecra%CC%83-2020-06-29-a%CC%80s-12.50.35-1000x600.png',
        publishedAt: '2020-06-29T12:09:09Z',
        source: {
            name: 'Hiper FM',
            url: 'https://www.hiper.fm/'
        }
    },
]

export default PTEntertainment;